import React, { useContext } from 'react'

import { RemindersContext } from '../context'
import { Index } from './Index/index'
import { Form } from './Form'
import { Destroy } from './Destroy'
import { Error } from './Error'

export const Views = () => {
  const { state: { view } } = useContext(RemindersContext)

  return (
    {
      index: () => <Index />,
      form: () => <Form />,
      destroy: () => <Destroy />,
      error: () => <Error />
    }[view || 'index']()
  )
}
